<br/>
<div class="container mx-auto">
    <h2>TrainView</h2>
    <app-system-wide-message></app-system-wide-message>
    <div class="system-wide-message alert alert-danger alert-dismissible fade show" role="alert" *ngIf="realtime == false">
        <div>There was an error retrieving the real-time data, please try refreshing.</div>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <app-train-search></app-train-search>
    <div class="row d-flex p-2 text-center">
        <table class="table table-bordered">
            <thead>
            <tr>
                <th scope="col">Train</th>
                <th scope="col">Line</th>
                <th scope="col" class="d-none d-sm-table-cell">Origin</th>
                <th scope="col" class="d-none d-sm-table-cell">Destination</th>
                <th scope="col" class="d-none d-sm-table-cell">Next</th>
                <th scope="col">Delay</th>
            </tr>
            </thead>
            <tbody>
                <tr *ngFor="let train of trains" [ngClass]="{'alert-warning': train.delay >= 10 }">
                    <td scope="row"><a  class="btn btn-link" routerLink="/trip/detail/{{train.id}}"> {{ train.id }} </a></td>
                    <td> {{ train.route.replace('/', ' ') }} </td>
                    <td class="d-none d-sm-table-cell"> {{ train.origin }} </td>
                    <td class="d-none d-sm-table-cell"> {{ train.destination }} </td>
                    <td class="d-none d-sm-table-cell"> {{ train.nextstop }} </td>
                    <td> {{ train.status }} </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<app-main-footer></app-main-footer>